import React, { useState, useEffect } from "react";
import "../styles/gallery.css";

const GalleryCard = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  /* =============================
     CLOSE POPUP (ESC + SCROLL LOCK)
  ============================= */
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      {/* ================= CARD ================= */}
      <div className="gallery-item" onClick={() => setIsOpen(true)}>
        {item?.image && (
          <img
            src={item.image}
            alt={item?.title || "Gallery"}
            className="gallery-img"
          />
        )}

        {item?.title && <h3 className="gallery-title">{item.title}</h3>}

        {item?.description && (
          <p className="gallery-description">{item.description}</p>
        )}

        {item?.category && (
          <small className="gallery-category">{item.category}</small>
        )}
      </div>

      {/* ================= FULLSCREEN POPUP ================= */}
      {isOpen && (
        <div className="fullscreen-overlay" onClick={() => setIsOpen(false)}>
          <div className="fullscreen-box" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              ×
            </button>

            {item?.image && (
              <img
                src={item.image}
                alt={item?.title}
                className="fullscreen-image"
              />
            )}

            {item?.title && <p className="fullscreen-title">{item.title}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryCard;
